import { IonRow, IonCol, IonText } from "@ionic/react";
import { SoundcloudPlayer } from "./SoundcloudPlayer";

export const Footer = (props) => {
  const {
    isMobile,
    isIntroPage,
    latestMix,
    projectTitle,
    handlePopupOpen,
    handlePopupClose,
    isVisible,
  } = props;

  if (isIntroPage) {
    return null;
  }

  return (
    <IonRow id="Footer" className="footer shadow-img">
      {!isMobile && (
        <IonCol className="copyright-text">
          <IonRow>
            <IonCol> &#9426; &nbsp; All rights reserved</IonCol>
          </IonRow>
        </IonCol>
      )}

      <SoundcloudPlayer
        isMobile={isMobile}
        latestMix={latestMix}
        handlePopupOpen={handlePopupOpen}
        handlePopupClose={handlePopupClose}
        isVisible={isVisible}
      />
      {!isMobile && (
        <IonCol className="footer-text">
          <IonText>Powered by {projectTitle}</IonText>
        </IonCol>
      )}
    </IonRow>
  );
};
